import { DataList } from '@radix-ui/themes';
import { EB } from 'components/layout/error-boundary';
import { ReactNode } from 'react';

export const CommonDataList = (props: {
  rows: { label: ReactNode; value: ReactNode }[];
}) => {
  return (
    <EB>
      <DataList.Root>
        {props.rows.map((r, i) => (
          <DataList.Item key={i}>
            <DataList.Label>{r.label}</DataList.Label>
            <DataList.Value>{r.value}</DataList.Value>
          </DataList.Item>
        ))}
      </DataList.Root>
    </EB>
  );
};
